<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="id"
    show-select
    style="padding: 25px"
    :items-per-page="10"
    :footer-props="{
      'items-per-page-options': [10, 25],
    }"
  >
    <template v-slot:top>
      <div>
        <div>
          <v-toolbar style="box-shadow: none !important">
            <v-toolbar-title>
              <b>{{ title }}</b>
            </v-toolbar-title>
          </v-toolbar>

          <div style="padding: 15px 25px 10px 27px">
            <v-layout row>
              <v-flex md8>
                <v-btn class="ml-1" small depressed v-on:click="formSearch">
                  Filter
                </v-btn>

                <v-btn class="ml-1" small depressed v-on:click="refreshAll">
                  Refresh
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1"
                  color="info"
                  small
                  depressed
                  v-on:click="backToQueue()"
                >
                  Back to Queue
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1 white--text"
                  color="orange"
                  small
                  depressed
                  v-on:click="rejectMaterialConfirm('', 'NI')"
                >
                  Return
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1"
                  color="error"
                  small
                  depressed
                  v-on:click="rejectMaterialConfirm('', 'RJT')"
                >
                  Reject
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1"
                  color="primary"
                  small
                  depressed
                  v-on:click="approvalProcess()"
                >
                  Request Approval
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1"
                  color="primary"
                  small
                  depressed
                  v-on:click="sendMaterialSap()"
                >
                  Send to SAP
                </v-btn>
              </v-flex>

              <v-flex md4>
                <v-text-field
                  label=""
                  v-model="val"
                  placeholder="Enter Your Keywords"
                  solo
                  v-on:keyup.enter="getMaterial()"
                  append-icon="search"
                  @click:append="getMaterial()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>

      <v-dialog v-model="loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading Data..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="form_search" max-width="500px">
        <v-card>
          <v-card-title> Filter List </v-card-title>
          <v-card-text>
            <div style="padding: 10px">
              <label> Status </label>
              <v-select
                item-text="STATUS_NAME"
                item-value="STATUS_ID"
                v-model="filter_status"
                :items="list_status"
                label="Choose Status"
                solo
              ></v-select>

              <div>
                <label>Start Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <label>End Date</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <label> Requester </label>
                <v-autocomplete
                  solo
                  item-text="NAME"
                  item-value="USER_ID"
                  v-model="filter_requester"
                  :items="list_requester"
                  label="Choose Requester"
                ></v-autocomplete>
              </div>
            </div>
            <div align="right">
              <v-btn
                rounded
                depressed
                class="mr-2"
                @click="form_search = false"
              >
                Close
              </v-btn>

              <v-btn
                color="primary"
                rounded
                depressed
                :loading="loading"
                v-on:click="getMaterial()"
              >
                Search
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="dialogDetailMaterial"
        v-model="dialogDetailMaterial"
        max-width="80%"
        scrollable
      >
        <detail-material
          :data="detail_data"
          @closeDialog="dialogDetailMaterial = false"
        ></detail-material>
      </v-dialog>

      <v-dialog
        v-if="dialogDetailMaterialExtend"
        v-model="dialogDetailMaterialExtend"
        max-width="90%"
        scrollable
      >
        <detail-material-initial
          :data="detail_data"
          type="edit"
          @closeDialog="dialogDetailMaterialExtend = false"
          @finishDialog=";(dialogDetailMaterialExtend = false), getMaterial()"
        ></detail-material-initial>
      </v-dialog>

      <v-dialog v-model="notification.open" max-width="350" persistent>
        <v-card>
          <v-card-title class="text-h6">
            {{ notification.title }}
          </v-card-title>

          <v-card-text>
            {{ notification.text }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="notification.color"
              dark
              depressed
              @click="notification.open = false"
            >
              Oke
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="dialogFeedBack"
        v-model="dialogFeedBack"
        max-width="500"
        scrollable
      >
        <feedback
          :data="feedback_data"
          @closeDialog="dialogFeedBack = false"
        ></feedback>
      </v-dialog>

      <v-dialog
        v-model="dialogConfirm"
        v-if="dialogConfirm"
        scrollable
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-text class="pt-5">
            <div class="text-h6">
              {{ confirm_title }}
            </div>
            <div class="mb-5" style="font-size: 15px">
              {{ confirm_text }}
            </div>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="feedback"
                  placeholder="Enter Feedback"
                  solo
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn depressed @click="dialogConfirm = false">
              Close
            </v-btn>
            <v-btn
              color="primary"
              depressed
              class="white--text"
              @click="rejectMaterialProcess()"
              :loading="loading_confirm"
            >
              Process
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="dialog_send_to_sap"
        v-model="dialog_send_to_sap"
        max-width="750"
        scrollable
        persistent
      >
        <v-card>
          <v-toolbar dark color="#06377a">
            <v-toolbar-title>
              Send to SAP
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn class="mr-1" icon dark @click="closeDialogSendToSAP()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <div class="mt-2">
              <v-row>
                <v-col md="8">
                  <div class="d-flex pt-4" style="gap: 15px">
                    <div style="color: #005780">
                      Total Upload : <b>{{ count_send_to_sap }}</b>
                    </div>

                    <div style="color: green">
                      Total Success : <b>{{ count_success_send_to_sap }}</b>
                    </div>

                    <div style="color: red">
                      Total Failed : <b>{{ count_error_send_to_sap }}</b>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div
              class="mt-5"
              style="height: 320px; background-color: rgb(247, 248, 248); margin-bottom: 10px; overflow-y: scroll"
            >
              <div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="20%">
                          Item Code
                        </th>
                        <th class="text-left" width="20%">
                          Item Name
                        </th>
                        <th class="text-left" width="20%">
                          Item Description
                        </th>
                        <th class="text-left" width="20%">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in reponse_send_to_sap"
                        :key="index"
                        :style="
                          row.status
                            ? 'background-color: #C8E6C9; color: #1B5E20'
                            : 'background-color: #FFEBEE; color: #D32F2F'
                        "
                      >
                        <td class="py-2">{{ row.inc_code }}</td>
                        <td class="py-2">{{ row.item_name }}</td>
                        <td class="py-2">{{ row.item_description }}</td>
                        <td class="py-2">
                          <span v-html="row.message"></span>

                          <v-icon
                            v-if="row.status"
                            color="#43A047"
                            style="font-size: 17px; margin-left: 3px"
                          >
                            mdi mdi-check-circle
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.open"
        :timeout="snackbar.timeout ? snackbar.timeout : 7000"
        top
      >
        {{ snackbar.message_text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackbar.button_type ? snackbar.button_type : 'primary'"
            v-bind="attrs"
            @click="snackbar.open = false"
          >
            {{ snackbar.button_text ? snackbar.button_text : "Close" }}
          </v-btn>
        </template>
      </v-snackbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <div style="position: relative">
            <v-btn text v-on="on" :disabled="selected.length > 1">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>

            <div v-if="item.feedback" class="dot"></div>
          </div>
        </template>
        <v-card>
          <v-list>
            <v-list-item-group>
              <v-list-item @click="openDialogFeedback(item)">
                <v-list-item-title style="width: 150px">
                  <div v-if="item.feedback" class="dot2"></div>
                  <v-icon color="#009688" class="menu-icon"
                    >mdi-comment-edit</v-icon
                  >
                  Feedback
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-on:click="openModalDetail(item)">
                <v-list-item-title>
                  <v-icon color="primary" class="menu-icon"
                    >mdi-file-document</v-icon
                  >
                  Detail
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="item.status === 'CAT' || item.status === 'DRAFT_CAT'"
                v-on:click="edit(item)"
              >
                <v-list-item-title>
                  <v-icon color="#03a9f4" class="menu-icon"
                    >mdi-file-edit</v-icon
                  >
                  Edit
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="item.status === 'CAT'"
                v-on:click="backToQueue(item)"
              >
                <v-list-item-title>
                  <v-icon color="#e95123" class="menu-icon"
                    >mdi-file-refresh</v-icon
                  >
                  Back to Queue
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="item.status != 'REG' && item.status != 'DRAFT_CAT'"
                v-on:click="approvalProcess(item)"
              >
                <v-list-item-title>
                  <v-icon color="#5c6bc0" class="menu-icon"
                    >mdi-file-chart-check</v-icon
                  >
                  Request Approval
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="item.status != 'REG' && item.status != 'DRAFT_CAT'"
                v-on:click="rejectMaterialConfirm(item, 'NI')"
              >
                <v-list-item-title>
                  <v-icon color="orange" class="menu-icon"
                    >mdi-file-arrow-left-right</v-icon
                  >
                  Return
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="
                  (item.status != 'REG' && item.status != 'DRAFT_CAT') ||
                    (item.status === 'DRAFT_CAT' && item.type_input === 'EXT')
                "
                v-on:click="rejectMaterialConfirm(item, 'RJT')"
              >
                <v-list-item-title>
                  <v-icon color="red" class="menu-icon">mdi-file-remove</v-icon>
                  Reject
                </v-list-item-title>
              </v-list-item>

              <v-divider
                v-if="item.status != 'REG' && item.status === 'DRAFT_CAT'"
              ></v-divider>

              <v-list-item
                v-if="item.status != 'REG' && item.status === 'DRAFT_CAT'"
                v-on:click="sendMaterialSap(item)"
              >
                <v-list-item-title>
                  <v-icon color="primary" class="menu-icon"
                    >mdi-cloud-upload</v-icon
                  >
                  Send to SAP
                </v-list-item-title>
              </v-list-item>

              <!-- <v-list-item v-on:click="sendMaterialSap(item)">
                <v-list-item-title>
                  <v-icon color="primary" class="menu-icon"
                    >mdi-cloud-upload</v-icon
                  >
                  Send to SAP
                </v-list-item-title>
              </v-list-item> -->
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </template>

    <template v-slot:item.status="{ item }">
      <status
        :status="item.status"
        :image_available="item.image_available"
        @eventDetail="openModalDetail(item)"
      ></status>
    </template>

    <template v-slot:item.price_information="{ item }">
      <div v-if="item.price_item" style="font-weight: bold;">
        IDR {{ item.price_item.toLocaleString().replace(/[,]/g, ".") }}
      </div>
      <div v-else>
        <v-btn depressed x-small style="color: #FF7043" color="#FBE9E7">
          Need Price Information
        </v-btn>
      </div>
    </template>

    <template v-slot:item.type_input="{ item }">
      <status :status="item.type_input"></status>
    </template>

    <template v-slot:item.part_number="{ item }">
      <td
        :style="{
          'background-color':
            item.possibility_duplicate === 'MEDIUM'
              ? '#FFB74D'
              : item.possibility_duplicate === 'HIGH'
              ? '#EF9A9A'
              : '',
        }"
        class="pa-5"
      >
        {{ item.part_number }}
      </td>
    </template>

    <template v-slot:item.manufacturer="{ item }">
      <td
        :style="
          item.possibility_duplicate === 'HIGH'
            ? 'background-color: #EF9A9A'
            : ''
        "
        class="pa-5"
      >
        {{ item.manufacturer }}
      </td>
    </template>

    <template v-slot:item.possibility_duplicate="{ item }">
      <status :status="item.possibility_duplicate"></status>
    </template>

    <template v-slot:item.basic_data_text="{ item }">
      <BasicDataText :data="item.basic_data_text"></BasicDataText>
    </template>
  </v-data-table>
</template>

<script>
import DetailMaterialVue from "../component/DetailMaterial.vue"
import FeedBackVue from "../component/FeedBack.vue"
import StatusVue from "../component/Status.vue"
import DetailMaterialInitialVue from "@/modules/component/DetailMaterialInitial.vue"
import BasicDataText from "../component/BasicDataText.vue"

export default {
  components: {
    "detail-material": DetailMaterialVue,
    feedback: FeedBackVue,
    status: StatusVue,
    "detail-material-initial": DetailMaterialInitialVue,
    BasicDataText,
  },
  data() {
    return {
      name: "Cataloguing",
      title: "Cataloguing List",
      storage: {
        session: true,
      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      singleSelect: false,
      selected: [],
      loading: false,
      loadingTable: true,
      loading_confirm: false,
      val: "",
      log: "",
      tab: "tab-1",
      tab2: "tab-1",
      headers: [
        {
          text: "Action",
          value: "action",
          sortable: false,
          width: 50,
          align: "center",
        },
        { text: "Status", value: "status", width: "180" },
        { text: "Description", value: "description", width: "300" },
        { text: "Price Information", value: "price_information", width: "170" },
        { text: "Request Number", value: "request_no", width: "150" },
        { text: "Request Type", value: "type_input", width: "130" },
        { text: "Requester", value: "request_by", width: "150" },
        { text: "Material Number", value: "material_number", width: "160" },
        { text: "Request Date", value: "request_date", width: "160" },
        { text: "INC Code", value: "inc_code", width: "130" },
        { text: "Item Name", value: "inc_name", width: "250" },
        { text: "Basic Data Text", value: "basic_data_text", width: "400" },
        { text: "Colloquial Name", value: "colloquial_name", width: "250" },
        { text: "Part Number", value: "part_number", width: "180" },
        { text: "Manufacturer", value: "manufacturer", width: "150" },
        { text: "Plant", value: "plant_name", width: "150" },
        { text: "Base Unit", value: "base_unit", width: "150" },
        { text: "Remarks", value: "remarks", width: "200" },
        {
          text: "Possibility Duplicate",
          value: "possibility_duplicate",
          width: "170",
        },
      ],
      desserts: [],
      list_message: [],
      list_message2: [],
      user_id: "",
      email_approval: "noreply@sinarmas.com",
      user_request: "",
      departement_id: "",
      username: "",
      user_approval: "",
      request_no: "",
      message: "",
      requester_message: "",
      requester_date: "",
      filter_requester: "",
      modal_message: "",
      modal_detail: false,
      detail: [],
      form_search: false,
      menu: false,
      menu2: false,
      user_cataloguer: "",
      list_approval_user: [],
      list_requester: [],

      //Dropdown......................................
      list_status: [
        { STATUS_ID: "CAT", STATUS_NAME: "Waiting Cataloguing" },
        { STATUS_ID: "DRAFT_CAT", STATUS_NAME: "Waiting Send to SAP" },
        { STATUS_ID: "REG", STATUS_NAME: "Registered On SAP" },
        { STATUS_ID: "FAIL", STATUS_NAME: "Failed" },
      ],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      storage_server: atob(localStorage.getItem("server")),
      dialogDetailMaterial: false,
      dialogDetailMaterialExtend: false,
      dialogFeedBack: false,
      detail_data: null,
      feedback_data: null,
      dialogConfirm: false,
      confirm_title: null,
      confirm_text: null,
      selected_status: null,
      selected_item: null,
      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
      notification: {
        open: false,
        title: null,
        text: null,
        color: "primary",
      },
      loading_send_to_sap: false,
      reponse_send_to_sap: [],
      dialog_send_to_sap: false,
      count_send_to_sap: 0,
      count_success_send_to_sap: 0,
      count_error_send_to_sap: 0,
    }
  },
  mounted() {
    this.getMaterial()
    this.getRequester()

    if (this.storage_role != "CAT") {
      this.$router.push("/login")
    }
  },
  methods: {
    getMaterial() {
      var self = this
      var val = self.val
      var url = self.base_url + "material/getdata/cataloguing_process"
      this.loading = true

      this.axios
        .post(url, {
          param: val,
          user_id: self.storage_user_id,
          filter_status: self.filter_status,
          filter_startdate: self.date,
          filter_enddate: self.date2,
          filter_requester: self.filter_requester,
        })
        .then(function(response) {
          self.desserts = response.data
          self.form_search = false
          self.loadingTable = false
          self.selected = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModalDetail(item) {
      this.detail_data = item
      this.dialogDetailMaterial = true
    },
    openDialogFeedback(item) {
      this.dialogFeedBack = true
      this.feedback_data = item
    },
    approvalProcess(item = null) {
      var checkRows = this.checkRows()
      if (checkRows > 0) {
        this.snackbar = {
          open: true,
          message_text: `There are ${checkRows} items that cannot be processed because the status has been process`,
          button_type: "error",
        }
        return false
      }

      const id = this.selected.length > 0 ? this.selectedRows() : item.id

      this.$dialog.confirm({
        text: "Are you sure you want to process this item ?",
        title: "Request Approval",
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: () => {
              var self = this
              var url = self.base_url + "material/process/request_approval"
              this.axios
                .post(url, {
                  id: id,
                  user_id: self.storage_user_id,
                  status: "APP1",
                  role: this.storage_role,
                })
                .then(function(response) {
                  if (response.status === 200) {
                    self.snackbar = {
                      open: true,
                      message_text: "Request approval success",
                      button_type: "primary",
                      button_text: "Ok",
                    }
                    self.getMaterial()
                  }
                })
                .catch(() => {
                  self.snackbar = {
                    open: true,
                    message_text: "Request approval failed",
                    button_type: "error",
                  }
                })
            },
          },
        },
      })
    },
    rejectMaterialConfirm(item = null, status) {
      var checkRows = this.checkRows()
      if (checkRows > 0) {
        this.snackbar = {
          open: true,
          message_text: `There are ${checkRows} items that cannot be processed because the status has been process`,
          button_type: "error",
        }
        return false
      }

      if (status === "RJT") {
        this.confirm_text = `Are you sure, you want to reject this item ?`
        this.confirm_title = "Reject material item"
      } else if (status === "NI") {
        this.confirm_text = `Are you sure, you want to return this item ?`
        this.confirm_title = "Return to requester"
      }

      this.selected_item = item
      this.selected_status = status
      this.dialogConfirm = true
    },
    rejectMaterialProcess() {
      var self = this
      const id =
        self.selected.length > 0 ? self.selectedRows() : self.selected_item.id

      if (!self.feedback) {
        self.snackbar = {
          open: true,
          message_text: `Feedback cannot be empty`,
          button_type: "error",
        }
        return false
      }

      self.loading_confirm = true
      var url = self.base_url + "material/process/reject"

      self.axios
        .post(url, {
          id: id,
          user_id: self.storage_user_id,
          status: self.selected_status,
          feedback: self.feedback,
          role: this.storage_role,
        })
        .then(function(response) {
          if (response.status === 200) {
            self.snackbar = {
              open: true,
              message_text: `${self.confirm_title} success`,
              button_type: "primary",
              button_text: "Ok",
            }
            self.feedback = null
            self.dialogConfirm = false
            self.loading_confirm = false
            self.getMaterial()
          }
        })
        .catch(() => {
          self.loading_confirm = false
          self.snackbar = {
            open: true,
            message_text: `${self.confirm_title} failed`,
            button_type: "error",
          }
        })
    },
    backToQueue(item = null) {
      var checkRows = this.checkRows()
      if (checkRows > 0) {
        this.snackbar = {
          open: true,
          message_text: `There are ${checkRows} items that cannot be processed because the status has been process`,
          button_type: "error",
        }
        return false
      }

      const id = this.selected.length > 0 ? this.selectedRows() : item.id

      this.$dialog.confirm({
        text: `Are you sure, you want to back to cataloguing queue this item ?`,
        title: `Back to cataloguing queue`,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: () => {
              var self = this
              var url = self.base_url + "material/process/return_cataloguing"
              this.axios
                .post(url, {
                  id: id,
                  user_id: self.storage_user_id,
                })
                .then(function(response) {
                  if (response.status === 200) {
                    self.snackbar = {
                      open: true,
                      message_text: `Back to cataloguing success`,
                      button_type: "primary",
                      button_text: "Ok",
                    }
                    self.getMaterial()
                  }
                })
                .catch(() => {
                  self.snackbar = {
                    open: true,
                    message_text: `Back to cataloguing failed`,
                    button_type: "error",
                  }
                })
            },
          },
        },
      })
    },
    formSearch() {
      this.form_search = true
    },
    edit(item) {
      if (item.type_input === "EXT") {
        this.detail_data = item
        this.dialogDetailMaterialExtend = true
      } else {
        var id = item.id
        var server = "GEMS"
        setTimeout(() => {
          this.$router.push({
            path: "/addRegister/" + btoa(server) + "/edit/" + btoa(id),
          })
        }, 100)
      }
    },
    refreshAll() {
      this.val = ""
      this.filter_status = ""
      this.filter_server = ""
      this.date = ""
      this.date2 = ""
      this.filter_requester = ""
      this.getMaterial()
    },
    checkRows() {
      var total = this.selected.length
      var a = 0
      for (var i = 0; i < total; i++) {
        if (
          this.selected[i].status === "REG" ||
          this.selected[i].status === "DRAFT_CAT" ||
          this.selected[i].status === "RJT"
        ) {
          a++
        }
      }
      return a
    },
    checkRowsSendToSAP() {
      var total = this.selected.length
      var a = 0
      for (var i = 0; i < total; i++) {
        if (
          this.selected[i].status === "REG" ||
          this.selected[i].status === "RJT"
        ) {
          a++
        }
      }
      return a
    },

    checkRowsItemPrice() {
      var total = this.selected.length
      var a = 0
      for (var i = 0; i < total; i++) {
        if (
          this.selected[i].item_price === "" ||
          !this.selected[i].item_price
        ) {
          a++
        }
      }
      return a
    },

    selectedRows() {
      var arritem = this.selected
      var item = ""

      if (arritem.length > 0) {
        for (var a = 0; a < arritem.length; a++) {
          item += "," + arritem[a].id
        }
        item = item.substring(1)
      }
      return item
    },
    async sendMaterialSap(item = null) {
      var checkRows = this.checkRowsSendToSAP()
      var checkRowsItemPrice = this.checkRowsItemPrice()

      if (checkRows > 0) {
        this.snackbar = {
          open: true,
          message_text: `Cannot process more item have been registered or rejected`,
          button_type: "error",
        }
        return false
      }

      var text = "Are you sure, you want send to SAP this item ?"

      if (item && !item.price_item) {
        text =
          "Price info has not been filled in, are you sure you will still send this item to SAP ?"
      }

      if (checkRowsItemPrice > 0) {
        text =
          "Price info has not been filled in, are you sure you will still send this item to SAP ?"
      }

      this.$dialog.confirm({
        text: text,
        title: `Send to SAP`,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: async () => {
              var self = this
              var response = {}
              var sap_callback = {}

              if (self.selected.length > 0) {
                self.loading_send_to_sap = true
                self.reponse_send_to_sap = []
                self.dialog_send_to_sap = true
                self.count_send_to_sap = 0
                self.count_error_send_to_sap = 0
                self.count_error_success_to_sap = 0

                for (const row of self.selected) {
                  response = await this.sendMaterialSAPService(row)
                  self.count_send_to_sap++

                  var send_sap_status = null
                  var send_sap_message = null
                  var send_sap_material_number = null

                  if (response && response.status) {
                    sap_callback = response.data.result
                      ? response.data.result
                          .ABM_MMM_112_MT_MATERIAL_DATA_RESPONSE
                      : {}

                    if (sap_callback.material_number) {
                      send_sap_status = true
                      self.count_success_send_to_sap++
                      send_sap_material_number = sap_callback.material_number
                    } else {
                      self.count_error_send_to_sap++
                      send_sap_status = false
                    }

                    send_sap_message = sap_callback.message
                  } else {
                    send_sap_message =
                      "Failed process send material to sap, error 500"
                    self.count_error_send_to_sap++
                    send_sap_status = false
                  }

                  var datax = {
                    inc_code: row.inc_code || "-",
                    item_name: row.inc_name || "-",
                    item_description: row.description || "-",
                    status: send_sap_status,
                    message: send_sap_message || "-",
                    material_number: send_sap_material_number || "-",
                  }

                  self.reponse_send_to_sap.push(datax)
                }

                self.getMaterial()
                self.loading_send_to_sap = false
              } else {
                self.loading = true
                response = await this.sendMaterialSAPService(item)

                if (response && response.status) {
                  sap_callback = response.data.result
                    ? response.data.result.ABM_MMM_112_MT_MATERIAL_DATA_RESPONSE
                    : {}

                  if (sap_callback.material_number) {
                    self.notification = {
                      open: true,
                      title: "Succesfully sent to SAP",
                      text: sap_callback.message,
                      color: "primary",
                    }
                  } else {
                    self.notification = {
                      open: true,
                      title: "Failed sent to SAP",
                      text: sap_callback.message || response.data.message,
                      color: "red",
                    }
                  }

                  self.getMaterial()
                  self.loading = false
                } else {
                  self.snackbar = {
                    open: true,
                    message_text:
                      "Failed process send material to sap, please check again your item",
                    button_type: "error",
                  }

                  self.loading = false
                }
              }
              // var url = self.base_url + "material/sap/submit"
              // self.loading = true

              // try {
              //   self.axios.post(url, item).then(function(response) {
              //     if (response.status === 200) {
              //       var data = response.data
              //       var sap_callback =
              //         data.result.ABM_MMM_112_MT_MATERIAL_DATA_RESPONSE

              //       if (sap_callback.material_number) {
              //         self.notification = {
              //           open: true,
              //           title: "Succesfully sent to SAP",
              //           text: sap_callback.message,
              //           color: "primary",
              //         }

              //         self.getMaterial()
              //       } else {
              //         self.notification = {
              //           open: true,
              //           title: "Failed sent to SAP",
              //           text: sap_callback.message,
              //           color: "red",
              //         }
              //       }

              //       self.loading = false
              //     }
              //   })
              // } catch (error) {
              //   self.snackbar = {
              //     open: true,
              //     message_text:
              //       "Failed process send material to sap, please check again your item",
              //     button_type: "error",
              //   }
              // }
            },
          },
        },
      })
    },
    async sendMaterialSAPService(item) {
      var self = this
      var url = self.base_url + "material/sap/submit"

      item.role = this.storage_role
      item.user_id = this.storage_user_id
      var res = {}

      try {
        var response = await self.axios.post(url, item)
        if (response.status === 200 || response.status === 204) {
          res = {
            status: true,
            data: response.data,
          }

          return res
        }
      } catch (error) {
        alert("error")
        res = {
          status: false,
          data: error,
        }

        return res
      }
    },

    closeDialogSendToSAP() {
      this.dialog_send_to_sap = false
      this.getMaterial()
    },

    getRequester() {
      var self = this
      var url = self.base_url + "dropdown/requester"
      self.axios.get(url).then(function(response) {
        self.list_requester = response.data
      })
    },
  },
}
</script>

<style>
.menu-icon {
  margin-top: -3px;
  margin-right: 10px;
}

.badge {
  position: absolute;
  margin-top: -1px;
  margin-left: -25px;
}

.dot {
  position: absolute;
  margin-top: -30px;
  margin-left: 38px;
  background-color: red;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.dot2 {
  position: absolute;
  margin-top: -5px;
  margin-left: 23px;
  background-color: red;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
</style>
